export interface ProgramCodeCellProps {
  original?: any;
}

export function ProgramCodeCell(props: ProgramCodeCellProps) {
  const { original } = props;

  if (!original) {
    return null;
  }

  const { items } = original;

  if (!items) {
    return null;
  }

  const programCode: string[] = [];

  items.forEach((value) => {
    const code = (value as any)?.programCode;

    if (code) {
      programCode.push(code);
    }
  });

  const programCodeDistinct = programCode.filter(function (item, pos) {
    return programCode.indexOf(item) === pos;
  });

  return <>{programCodeDistinct.join("/")}</>;
}
